/*! YMM Audio Examples — Elfsight-like playlist player */
(function () {
  function fmt(sec) {
    if (!isFinite(sec) || sec < 0) return '0:00';
    var m = Math.floor(sec / 60);
    var s = Math.floor(sec % 60);
    return m + ':' + (s < 10 ? '0' : '') + s;
  }

  function clamp(n, a, b) {
    return Math.max(a, Math.min(b, n));
  }

  function init(root) {
    if (!root || root.dataset.ymmAudioReady === '1') return;
    var tracks = [];
    try {
      tracks = JSON.parse(root.getAttribute('data-tracks') || '[]');
    } catch (e) {
      tracks = [];
    }
    if (!tracks.length) return;
    root.dataset.ymmAudioReady = '1';

    var audio = root.querySelector('[data-ymm-audio]');
    var playBtn = root.querySelector('[data-ymm-play]');
    var prevBtn = root.querySelector('[data-ymm-prev]');
    var nextBtn = root.querySelector('[data-ymm-next]');
    var seek = root.querySelector('[data-ymm-seek]');
    var seekWrap = root.querySelector('[data-ymm-seek-wrap]');
    var progressBlock = root.querySelector('.ymm-audio__progress-block');
    var curEl = root.querySelector('[data-ymm-current]');
    var durEl = root.querySelector('[data-ymm-duration]');
    var titleEl = root.querySelector('[data-ymm-title]');
    var coverImg = root.querySelector('[data-ymm-cover-img]');
    var coverFallback = root.querySelector('[data-ymm-cover-fallback]');
    var shuffleBtn = root.querySelector('[data-ymm-shuffle]');
    var repeatBtn = root.querySelector('[data-ymm-repeat]');
    var volumeBtn = root.querySelector('[data-ymm-volume-btn]');
    var volumeWrap = root.querySelector('[data-ymm-volume-wrap]');
    var volumePanel = root.querySelector('[data-ymm-volume-panel]');
    var volumeRail = root.querySelector('[data-ymm-volume-rail]');
    var playlistBtn = root.querySelector('[data-ymm-playlist-btn]');
    var playlistWrap = root.querySelector('.ymm-audio__playlist-wrap');
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-ymm-track]'));

    var index = 0;
    var seeking = false;
    var shuffle = false;
    var repeatMode = 'off';
    var volumePct = 100;
    var order = tracks.map(function (_, i) { return i; });

    function setCover(url, altText) {
      if (!coverImg) return;
      if (url) {
        coverImg.hidden = false;
        if (coverFallback) coverFallback.hidden = true;
        if (coverImg.getAttribute('src') !== url) coverImg.src = url;
        coverImg.alt = altText || 'Custom song example – YourMelodyMakers';
      } else {
        coverImg.removeAttribute('src');
        coverImg.hidden = true;
        coverImg.alt = '';
        if (coverFallback) coverFallback.hidden = false;
      }
    }

    function paintActive() {
      items.forEach(function (btn, i) {
        btn.classList.toggle('is-active', i === index);
        btn.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    }

    function rebuildOrder(keepCurrent) {
      var currentId = index;
      order = tracks.map(function (_, i) { return i; });
      if (shuffle) {
        for (var i = order.length - 1; i > 0; i--) {
          var j = Math.floor(Math.random() * (i + 1));
          var tmp = order[i];
          order[i] = order[j];
          order[j] = tmp;
        }
        if (keepCurrent) {
          var pos = order.indexOf(currentId);
          if (pos > 0) {
            order.splice(pos, 1);
            order.unshift(currentId);
          }
        }
      }
    }

    function setProgress(pct) {
      var v = clamp(pct, 0, 100);
      if (seek) seek.value = String(v);
      if (progressBlock) progressBlock.style.setProperty('--ea-progress', v + '%');
    }

    function setVolume(pct) {
      volumePct = clamp(pct, 0, 100);
      audio.volume = volumePct / 100;
      if (volumeWrap) volumeWrap.style.setProperty('--ea-volume', volumePct + '%');
    }

    function load(i, autoplay) {
      index = (i + tracks.length) % tracks.length;
      var t = tracks[index];
      audio.src = t.src;
      if (titleEl) titleEl.textContent = t.label || t.title || 'Track';
      setCover(t.cover || '', t.label || t.title || 'Custom song example – YourMelodyMakers');
      if (durEl) durEl.textContent = t.durationLabel || '0:00';
      setProgress(0);
      if (curEl) curEl.textContent = '0:00';
      paintActive();
      if (autoplay) {
        var p = audio.play();
        if (p && p.catch) p.catch(function () {});
      }
    }

    function step(dir) {
      var pos = order.indexOf(index);
      if (pos < 0) pos = 0;
      var nextPos = pos + dir;
      if (nextPos < 0) nextPos = order.length - 1;
      if (nextPos >= order.length) nextPos = 0;
      load(order[nextPos], true);
    }

    function syncPlayUi() {
      if (!playBtn) return;
      var playing = !audio.paused;
      playBtn.setAttribute('aria-pressed', playing ? 'true' : 'false');
      playBtn.setAttribute('aria-label', playing ? 'Pause' : 'Play');
    }

    function seekFromClientX(clientX) {
      if (!seekWrap || !audio.duration) return;
      var rect = seekWrap.getBoundingClientRect();
      var pct = clamp(((clientX - rect.left) / rect.width) * 100, 0, 100);
      setProgress(pct);
      audio.currentTime = (pct / 100) * audio.duration;
    }

    function volumeFromClientY(clientY) {
      if (!volumeRail) return;
      var rect = volumeRail.getBoundingClientRect();
      var pct = clamp(((rect.bottom - clientY) / rect.height) * 100, 0, 100);
      setVolume(pct);
    }

    if (playBtn) {
      playBtn.addEventListener('click', function () {
        if (audio.paused) {
          var p = audio.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          audio.pause();
        }
      });
    }
    if (prevBtn) prevBtn.addEventListener('click', function () { step(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });

    items.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var i = parseInt(btn.getAttribute('data-ymm-track'), 10) || 0;
        load(i, true);
      });
    });

    if (shuffleBtn) {
      shuffleBtn.addEventListener('click', function () {
        shuffle = !shuffle;
        shuffleBtn.classList.toggle('is-on', shuffle);
        shuffleBtn.setAttribute('aria-pressed', shuffle ? 'true' : 'false');
        rebuildOrder(true);
      });
    }

    if (repeatBtn) {
      repeatBtn.addEventListener('click', function () {
        if (repeatMode === 'off') repeatMode = 'all';
        else if (repeatMode === 'all') repeatMode = 'one';
        else repeatMode = 'off';
        repeatBtn.classList.toggle('is-on', repeatMode !== 'off');
        repeatBtn.setAttribute('aria-pressed', repeatMode !== 'off' ? 'true' : 'false');
        repeatBtn.setAttribute('aria-label', 'Repeat: ' + repeatMode);
        audio.loop = repeatMode === 'one';
      });
    }

    if (seekWrap) {
      seekWrap.addEventListener('pointerdown', function (e) {
        seeking = true;
        seekWrap.setPointerCapture(e.pointerId);
        seekFromClientX(e.clientX);
      });
      seekWrap.addEventListener('pointermove', function (e) {
        if (!seeking) return;
        seekFromClientX(e.clientX);
      });
      function endSeek(e) {
        if (!seeking) return;
        seeking = false;
        try { seekWrap.releasePointerCapture(e.pointerId); } catch (err) {}
      }
      seekWrap.addEventListener('pointerup', endSeek);
      seekWrap.addEventListener('pointercancel', endSeek);
    }

    if (volumeBtn && volumeWrap && volumePanel && volumeRail) {
      volumeBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = volumePanel.hasAttribute('hidden');
        if (open) volumePanel.removeAttribute('hidden');
        else volumePanel.setAttribute('hidden', '');
        volumeBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });

      var draggingVol = false;
      volumeRail.addEventListener('pointerdown', function (e) {
        e.preventDefault();
        e.stopPropagation();
        draggingVol = true;
        volumeRail.setPointerCapture(e.pointerId);
        volumeFromClientY(e.clientY);
      });
      volumeRail.addEventListener('pointermove', function (e) {
        if (!draggingVol) return;
        volumeFromClientY(e.clientY);
      });
      function endVol(e) {
        if (!draggingVol) return;
        draggingVol = false;
        try { volumeRail.releasePointerCapture(e.pointerId); } catch (err) {}
      }
      volumeRail.addEventListener('pointerup', endVol);
      volumeRail.addEventListener('pointercancel', endVol);

      document.addEventListener('click', function (e) {
        if (!volumeWrap.contains(e.target)) {
          volumePanel.setAttribute('hidden', '');
          volumeBtn.setAttribute('aria-expanded', 'false');
        }
      });
    }

    if (playlistBtn && playlistWrap) {
      playlistBtn.addEventListener('click', function () {
        var open = playlistWrap.hasAttribute('hidden');
        if (open) playlistWrap.removeAttribute('hidden');
        else playlistWrap.setAttribute('hidden', '');
        playlistBtn.classList.toggle('is-on', open);
        playlistBtn.setAttribute('aria-pressed', open ? 'true' : 'false');
      });
    }

    audio.addEventListener('play', syncPlayUi);
    audio.addEventListener('pause', syncPlayUi);
    audio.addEventListener('ended', function () {
      if (repeatMode === 'one') {
        audio.currentTime = 0;
        audio.play();
        return;
      }
      var pos = order.indexOf(index);
      if (pos === order.length - 1 && repeatMode === 'off') {
        syncPlayUi();
        return;
      }
      step(1);
    });
    audio.addEventListener('loadedmetadata', function () {
      if (durEl) durEl.textContent = fmt(audio.duration);
    });
    audio.addEventListener('timeupdate', function () {
      if (!audio.duration) return;
      if (curEl) curEl.textContent = fmt(audio.currentTime);
      if (!seeking) setProgress((audio.currentTime / audio.duration) * 100);
    });

    rebuildOrder(false);
    setVolume(100);
    load(0, false);
    setProgress(0);
  }

  function boot() {
    var nodes = document.querySelectorAll('[data-ymm-audio-root]');
    if (!nodes.length) return;
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            init(entry.target);
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '200px 0px' });
      nodes.forEach(function (n) { io.observe(n); });
    } else {
      nodes.forEach(init);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target && e.target.querySelector ? e.target.querySelector('[data-ymm-audio-root]') : null;
    if (root) {
      root.dataset.ymmAudioReady = '';
      init(root);
    }
  });
})();
